import styled from 'styled-components'
import { margin, MarginProps, width, WidthProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<WidthProps>`
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.background.screen')};
  padding: ${themeGet('space.6')}px;
  gap: ${themeGet('space.4')}px;
  border-radius: 12px;
  height: 100%;

  img:first-child {
    height: 25px;
    object-fit: contain;
    object-position: left;
  }

  img:last-child {
    height: 80px;
    width: 80px;
    object-fit: contain;
    border-radius: 40px;

    @media screen and (min-width: ${themeGet('breakpoints.4')}) {
      height: 120px;
      width: 120px;
      border-radius: 60px;
    }
  }

  ${width}
`

export const Divider = styled.div.withConfig({
  shouldForwardProp,
})<MarginProps>`
  width: 100%;
  height: 1px;
  background-color: ${themeGet('colors.line.tertiary')};

  ${margin}
`
